import { BsMegaphone } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditAdsAndLeads = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsMegaphone',
				label: 'megaphone',
				component: BsMegaphone,
			}}
			defaultTheme="orange"
			widgetType="adsAndLeads"
		/>
	);
};

export default EditAdsAndLeads;
